module.exports = __webpack_public_path__ + "media/images/gallery/names_on-cd6b4e1dfe199557c2b51f09766c933a.gif";